var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCartWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.412,
    height: 32.366,
    viewBox: "0 0 36.412 32.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-shopping-cart",
    "data-name": "Icon awesome-shopping-cart",
    d: "M33.385,19.048,36.374,5.9a1.517,1.517,0,0,0-1.479-1.853H10.064L9.485,1.213A1.517,1.517,0,0,0,8,0H1.517A1.517,1.517,0,0,0,0,1.517V2.529A1.517,1.517,0,0,0,1.517,4.046H5.935l4.441,21.71a3.54,3.54,0,1,0,4.238.541H27.867a3.539,3.539,0,1,0,4.02-.658l.349-1.535a1.517,1.517,0,0,0-1.479-1.853H13.788l-.414-2.023H31.906A1.517,1.517,0,0,0,33.385,19.048Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartWhite);
export default __webpack_public_path__ + "static/media/shopping_cart_white.c604723c78d592718f6af6bf3dd078df.svg";
export { ForwardRef as ReactComponent };